import React from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  icon: any;
  notificationCount?: number;
}

const useStyles = createUseStyles({
  root: {
    position: 'relative',
  },
  badge: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'end',
    position: 'absolute',
    top: -3,
    right: -4,
    borderRadius: '50%',
    height: 13,
    width: 13,
    fontSize: 8,
    fontWeight: 700,
    color: 'white',
    backgroundColor: '#fa5c7c',
  },
});

const NotifButton: React.FC<Props> = ({ icon: Icon, notificationCount, ...props }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Icon {...props} />
      {(notificationCount || 0) > 0 && <span className={classes.badge}>{notificationCount}</span>}
    </div>
  );
};

export default NotifButton;
